module.exports = __webpack_public_path__ + "Tinebase/js/ace-theme-vibrant_ink-FAT.js";